import { UserType } from '../../../../../enums/UserType';
import { JobDetailsUserBoxV2 } from '../../../Job/JobDetailsUserBoxV2';
import { JobFindUserPlaceholderV2 } from '../../../Job/JobFindUserPlaceholderV2';
import { FormCard } from '../../shared/FormCard';

export const OfficeSelectionCard = ({ formValues, handleChange }) => (
  <FormCard style={{ marginTop: 32, paddingBlock: 22 }} contentStyle={{ width: '80%' }}>
    {formValues.office ? (
      <JobDetailsUserBoxV2 user={formValues.office} onCancel={() => handleChange('office', null)} />
    ) : (
      <JobFindUserPlaceholderV2
        title="+ Add a Dental Office"
        userType={UserType.DNT}
        onSelectUser={(office) => handleChange('office', office)}
      />
    )}
  </FormCard>
);
